import { render, staticRenderFns } from "./addGoldenRules.vue?vue&type=template&id=1c0c3eff&scoped=true&"
import script from "./addGoldenRules.vue?vue&type=script&lang=js&"
export * from "./addGoldenRules.vue?vue&type=script&lang=js&"
import style0 from "./addGoldenRules.vue?vue&type=style&index=0&id=1c0c3eff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c3eff",
  null
  
)

export default component.exports